export default [
    {
        meta: {
            requiresAuth: true,
            role: "admin",
            layout: "AdminLayout",
        },
        children: [
            {
                path: "/admin-activity-log-dashboard",
                name: "admin-activity-log-dashboard",
                component: () => import("@/Pages/AdminActivityLog/Dashboard.vue"),
            },
            {
                path: "/admin-activity-log-data",
                component: () => import("@/Pages/AdminActivityLog/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "admin-activity-log-data",
                        component: () =>
                            import("@/Pages/AdminActivityLog/List.vue"),
                    },
                    {
                        path: "create",
                        name: "admin-activity-log-data-create",
                        component: () =>
                            import("@/Pages/AdminActivityLog/Create.vue"),
                    },
                    {
                        path: ":id",
                        name: "admin-activity-log-data-show",
                        component: () =>
                            import("@/Pages/AdminActivityLog/Show.vue"),
                    },
                    {
                        path: ":id/edit",
                        name: "admin-activity-log-data-edit",
                        component: () =>
                            import("@/Pages/AdminActivityLog/Edit.vue"),
                    },
                ],
            },
        ],
    },
];
